// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SpecialInstruction = t.struct({
    description: t.String,
    id: t.String,
    parentId: t.String
}, {
    name: 'SpecialInstruction',
    strict: true
});

export const getDefaultState = () => new SpecialInstruction({
    description: '',
    id: '',
    parentId: ''
});

export default SpecialInstruction;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/special-instruction.js